<template>
    <button type="button" @click="click">
        <slot></slot>
    </button>
</template>

<script>
  export default {
      data () {
          return {
              pressed: false
          }
      },
      methods: {
          click () {
              this.pressed = true
              this.$emit('click')
          }
      }
  }
</script>